import React, { useState } from 'react';
import './AccountSettingsGrid.css';
import ManageAddresses from './ManageAddresses';
import AccountDetails from './AccountDetails';
import Security from './Security';
import Notifications from './Notifications';
import { FaBox, FaMapMarkerAlt, FaCreditCard, FaUser, FaLock, FaBell } from 'react-icons/fa';

function AccountSettingsGrid({ onShowOrders, onClose, userId, user }) {
  const [showAddresses, setShowAddresses] = useState(false);
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const [showSecurity, setShowSecurity] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const handleAddresses = () => {
    setShowAddresses(true);
  };

  const handlePaymentMethods = () => {
    alert('Payment methods feature coming soon!');
  };

  const handleAccountDetails = () => {
    setShowAccountDetails(true);
  };

  const handleSecurity = () => {
    setShowSecurity(true);
  };

  const handleNotifications = () => {
    setShowNotifications(true);
  };

  const settingsCards = [
    {
      icon: <FaBox />,
      title: 'Your Orders',
      desc: 'Track, return, or buy things again',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      onClick: () => { onShowOrders(); }
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Your Addresses',
      desc: 'Edit addresses for orders and gifts',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      onClick: handleAddresses
    },
    {
      icon: <FaCreditCard />,
      title: 'Payment Methods',
      desc: 'Manage payment methods and settings',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      onClick: handlePaymentMethods
    },
    {
      icon: <FaUser />,
      title: 'Account Details',
      desc: 'Edit login, name, and mobile number',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      onClick: handleAccountDetails
    },
    {
      icon: <FaLock />,
      title: 'Security',
      desc: 'Update password and security settings',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      onClick: handleSecurity
    },
    {
      icon: <FaBell />,
      title: 'Notifications',
      desc: 'Manage your notification preferences',
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      onClick: handleNotifications
    }
  ];

  return (
    <div className="dashboard-section settings-section">
      <h3>Quick Access</h3>
      <div className="settings-grid">
        {settingsCards.map((card, index) => (
          <div 
            key={index} 
            className="setting-card"
            onClick={card.onClick}
            style={{ cursor: 'pointer' }}
          >
            <div className="setting-icon-wrapper" style={{ background: card.gradient }}>
              <span className="setting-icon">{card.icon}</span>
            </div>
            <div className="setting-content">
              <h4>{card.title}</h4>
              <p>{card.desc}</p>
            </div>
            <span className="setting-arrow">→</span>
          </div>
        ))}
      </div>

      {showAddresses && <ManageAddresses userId={userId} onClose={() => setShowAddresses(false)} />}
      {showAccountDetails && <AccountDetails userId={userId} onClose={() => setShowAccountDetails(false)} />}
      {showSecurity && <Security userId={userId} onClose={() => setShowSecurity(false)} />}
      {showNotifications && <Notifications userId={userId} onClose={() => setShowNotifications(false)} isDropdown={false} />}
    </div>
  );
}

export default AccountSettingsGrid;
